import React from 'react';
import './title-modal.scss';

export default props => (
    <h2 className="title-modal">{props.title}</h2>
)
